"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputStepper = void 0;
const merlin_button_icon_1 = require("@travelnest/merlin.button-icon");
const React = __importStar(require("react"));
const input_stepper_styled_1 = require("./input-stepper.styled");
const InputStepper = (props) => {
    const { id, onClick, value = 1, minValue = 1, maxValue = 100, step = 1, valueFormatter = (val) => val.toString(), widthOverride = '335px' } = props;
    const onChange = (val) => {
        if (val > maxValue) {
            onClick(maxValue);
        }
        else if (val < minValue) {
            onClick(minValue);
        }
        else {
            onClick(val);
        }
    };
    return (React.createElement(input_stepper_styled_1.StyledClicker, { id: id, widthOverride: widthOverride },
        React.createElement(merlin_button_icon_1.IconButton, { onClick: (e) => {
                e.preventDefault();
                e.stopPropagation();
                onChange(value - step);
            }, disabled: value === minValue, icon: "minus" }),
        React.createElement("span", { className: "value" }, valueFormatter(value)),
        React.createElement(merlin_button_icon_1.IconButton, { onClick: () => onChange(value + step), disabled: value === maxValue, icon: "plus" })));
};
exports.InputStepper = InputStepper;
//# sourceMappingURL=InputStepper.js.map